import { ResponsiveProps } from '@cbhq/cds-web';
import { VStack } from '@cbhq/cds-web/layout';
import { Link, TextBody, TextHeadline } from '@cbhq/cds-web/typography';

import { CLOUD_HELP } from ':cloud/utils/links';
import { MeterTiers } from ':cloud/widgets/waasProjects/MeterTiers';

const responsiveConfig: ResponsiveProps = {
  phone: { spacingTop: 4 },
  tablet: { spacingTop: 8 },
  desktop: { spacingTop: 8 },
};

type WaasNewProjectRightRailProps = {
  isLoading: boolean;
};

export function NewProjectRightRail({ isLoading }: WaasNewProjectRightRailProps) {
  return (
    <VStack gap={7} responsiveConfig={responsiveConfig}>
      <MeterTiers isLoading={isLoading} />
      <VStack alignItems="center" gap={1}>
        <TextHeadline as="p">Need an enterprise plan?</TextHeadline>
        <TextBody as="p" align="center" color="foregroundMuted">
          For custom plans with larger volumes <br />{' '}
          <Link to={CLOUD_HELP} underline={false} openInNewWindow>
            contact support
          </Link>
          .
        </TextBody>
      </VStack>
    </VStack>
  );
}
